import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Overview from "../pages/Overview";
import ProtectedRoute from "./AuthGuard";
import Header from "../pages/Header";
import Footer from "../pages/Footer/Footer";
import { useAuth } from "../context/AuthContext";
import ReviewCustomers from "../modules/surcharge-processing/pages/ReviewCustomers";
import ReviewProductionIndices from "../modules/surcharge-processing/pages/ReviewProductionIndices";
import RunSurchargeIncrease from "../modules/surcharge-processing/pages/RunSurchargeIncrease";
import ReviewNewCharges from "../modules/surcharge-processing/pages/ReviewNewCharges";
import ReviewSendEmails from "../modules/surcharge-processing/pages/ReviewSendEmails/ReviewSendEmails";
import ToastMessage from "../components/ToastMessage";
import { selectToastInfo, closeToast } from "../redux/shareSlice";
import { store } from "../store/store";
import { Pages } from "../shared/constants";

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const toastInfo = useSelector(selectToastInfo);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && window.location.pathname === "/") {
      console.log("User authenticated, navigating to /overview...");
      navigate(Pages.SurchargeProcessing, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Header />
      <ToastMessage toastInfo={toastInfo} onHiding={() => store.dispatch(closeToast({}))} />
      <Routes>
        {/* Default Route */}
        <Route path="/" element={<Navigate to={Pages.SurchargeProcessing} />} />

        {/* Overview Page (Persistent Tabs) */}
        <Route
          path="/overview"
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          }
        />

        {/* Nested Routing for Surcharge Processing */}
        <Route
          path={Pages.SurchargeProcessing}
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          }
        >
          <Route index element={<ReviewCustomers />} /> {/* Default Step */}
          <Route path="review-customers" element={<ReviewCustomers />} />
          <Route path="review-production" element={<ReviewProductionIndices />} />
          <Route path="run-increase" element={<RunSurchargeIncrease />} />
          <Route path="review-charges" element={<ReviewNewCharges />} />
          <Route path="review-emails" element={<ReviewSendEmails />} />
        </Route>

        {/* Additional Module Routes */}
        <Route
          path={Pages.Reporting}
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          }
        />
        <Route
          path={Pages.FormulaSimulator}
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          }
        />

        {/* Catch-all Redirect */}
        <Route path="*" element={<Navigate to="/overview" />} />
      </Routes>
      <Footer />
    </>
  );
};

export default AppRoutes;
